import { render, staticRenderFns } from "./BindCard.vue?vue&type=template&id=f0b8986a&scoped=true"
import script from "./BindCard.vue?vue&type=script&lang=js"
export * from "./BindCard.vue?vue&type=script&lang=js"
import style0 from "./BindCard.vue?vue&type=style&index=0&id=f0b8986a&prod&lang=css"
import style1 from "./BindCard.vue?vue&type=style&index=1&id=f0b8986a&prod&lang=less&scoped=true"
import style2 from "./BindCard.vue?vue&type=style&index=2&id=f0b8986a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b8986a",
  null
  
)

export default component.exports